import React from 'react';

export default function ProgressBar({ progress, visible, label = 'Loading data…' }) {
  if (!visible) return null;
  return (
    <div style={{
      position: 'fixed',
      top: 0,
      left: 0,
      right: 0,
      bottom: 0,
      zIndex: 9999,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'rgba(10, 18, 35, 0.55)',
      backdropFilter: 'blur(4px)',
      WebkitBackdropFilter: 'blur(4px)',
    }}>
      <div style={{
        background: '#0f172a',
        border: '1px solid rgba(255,255,255,0.08)',
        borderRadius: 16,
        boxShadow: '0 8px 40px rgba(0,0,0,0.5)',
        padding: '28px 36px',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        gap: 14,
        minWidth: 260,
      }}>
        <div style={{
          fontFamily: "'Inter', -apple-system, sans-serif",
          fontWeight: 600,
          fontSize: 13,
          color: '#94a3b8',
          letterSpacing: '0.04em',
          textTransform: 'uppercase',
        }}>
          {label}
        </div>
        <div style={{
          width: '100%',
          height: 5,
          background: 'rgba(255,255,255,0.08)',
          borderRadius: 3,
          overflow: 'hidden',
        }}>
          <div style={{
            width: `${progress}%`,
            height: '100%',
            background: 'linear-gradient(90deg, #1d4ed8, #3b82f6)',
            borderRadius: 3,
            transition: 'width 0.35s ease',
            boxShadow: '0 0 10px rgba(59,130,246,0.6)',
          }} />
        </div>
        <div style={{
          fontFamily: "'Inter', -apple-system, sans-serif",
          fontWeight: 700,
          fontSize: 15,
          color: '#e2e8f0',
          fontVariantNumeric: 'tabular-nums',
        }}>
          {progress}%
        </div>
      </div>
    </div>
  );
}
